import { AfterContentChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';

@Component({
  selector: 'app-upward-accordion',
  templateUrl: './upward-accordion.component.html',
  styleUrls: ['./upward-accordion.component.scss']
})
export class UpwardAccordionComponent implements AfterContentChecked, AfterViewInit {
  @Input() public hasHeader = true;
  @Output() public onClose = new EventEmitter<void>();

  @ViewChild('content') private content?: ElementRef<HTMLElement>;

  private readonly element: ElementRef<HTMLElement> = inject(ElementRef);
  protected isOpen = false;
  protected elementHeight = 0;
  protected contentHeight = 0;
  protected overlayActive = false;

  ngAfterContentChecked(): void {
    this.elementHeight = this.element.nativeElement.getBoundingClientRect().top;
    this.contentHeight = this.content?.nativeElement.scrollHeight ?? 0;
  }

  ngAfterViewInit(): void {
    if (!this.hasHeader) {
      this.toggle();
    }
  }

  protected async toggle(): Promise<void> {
    this.isOpen = !this.isOpen;

    if (!this.overlayActive) {
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
    this.overlayActive = !this.overlayActive;

    if (!this.isOpen) {
      await new Promise((resolve) => setTimeout(resolve, 200));
      this.onClose.emit();
    }
  }
}
